import { clsx } from 'clsx';

import { Dialog, Icon, IconButton } from '@/ui';

import { MENTO_LOGO_URL } from './constants';

import type { FC, ReactNode } from 'react';

interface MentoCalPageShellProps {
  children: ReactNode;
  labelledBy: string;
  onClose: () => void;
  presentation?: 'default' | 'member-reschedule';
}

export const MentoCalPageShell: FC<MentoCalPageShellProps> = ({
  children,
  labelledBy,
  onClose,
  presentation = 'default',
}) => (
  <Dialog
    aria-labelledby={labelledBy}
    PaperProps={{ 'aria-modal': true }}
    fullScreen
    open
    onClose={onClose}
  >
    <main className="fixed inset-0 z-50 overflow-y-auto bg-white max-md:p-0 md:bg-sunny-100 md:px-4 md:py-8">
      <IconButton
        aria-label="Close"
        className={clsx(
          'absolute right-4 top-4 z-10 md:right-6 md:top-6',
          presentation === 'member-reschedule' && '!bg-transparent',
        )}
        autoFocus
        onClick={onClose}
      >
        <Icon>close</Icon>
      </IconButton>
      <div
        className={clsx(
          'mx-auto flex w-full max-w-[1141px] flex-col items-center gap-16 pt-8 max-md:gap-0 max-md:pt-0',
          presentation === 'member-reschedule' && 'md:pt-[92px]',
        )}
        data-testid="mentocal-page-content"
      >
        <div
          className="flex h-[68px] w-full shrink-0 items-center justify-center border-b border-cement-200 md:h-auto md:border-0"
          data-testid="mentocal-page-header"
        >
          <img alt="Mento" className="h-8" src={MENTO_LOGO_URL} />
        </div>
        {children}
      </div>
    </main>
  </Dialog>
);
